import React from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { ChangeEvent } from "utils/history/Event";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import {
	InformationRight,
	InformationRights
} from "core/blueprint/trajectory/TrajectoryBlueprintService";
import { GroupField } from "../FieldService";
import FieldInput from "./FieldInput";
import ExpressionParser from "../parser/ExpressionParser";

export type GroupInputProps = {
	field: GroupField;
	editable: boolean;
	rights: InformationRights;
	parser?: ExpressionParser;

	onChange: (event: ChangeEvent, valid: boolean) => void;
};

const GroupInput: React.FC<GroupInputProps> = (props: GroupInputProps) => {
	function onChange(
		index: number,
		change: ChangeEvent,
		valid: boolean
	): void {
		change.applyContext("/children/" + index);
		props.onChange(change, valid);
	}

	return (
		<Grid item xs={12}>
			<Accordion
				disableGutters
				elevation={0}
				defaultExpanded={!props.field.collapsed}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					sx={{
						flexDirection: "row-reverse",
						padding: 0,
						minHeight: 0,
						"& .MuiAccordionSummary-content": {
							margin: 0
						}
					}}>
					<Typography variant="h6" sx={{ wordWrap: "break-word" }}>
						{props.field.name}
					</Typography>
				</AccordionSummary>
				<AccordionDetails
					sx={theme => ({
						padding: 0,
						borderTop: `1px solid ${theme.palette.divider}`,
						borderBottom: `1px solid ${theme.palette.divider}`
					})}>
					<Grid item container columnSpacing={4} alignItems="center">
						{props.field.children
							.filter(
								child =>
									props.rights[child.uuid]?.[
										InformationRight.READ
									]
							)
							.map((child, index) => (
								<FieldInput
									key={child.uuid}
									field={child}
									editable={props.editable}
									rights={props.rights}
									parser={props.parser}
									onChange={(event, valid) =>
										onChange(index, event, valid)
									}
								/>
							))}
					</Grid>
				</AccordionDetails>
			</Accordion>
		</Grid>
	);
};

export default GroupInput;
